import Marquee from "react-fast-marquee";
import { Container, FadeUp } from "./primitives";

const USE_CASES = [
  "Marketing Agency",
  "Sales Team",
  "Startup Founder",
  "Recruitment",
  "B2B SaaS",
  "Community Manager",
  "Digital Consultant",
  "Real Estate",
  "Automotive",
  "Education",
];

export default function UseCases() {
  return (
    <section id="use-cases" data-testid="use-cases-section" className="relative py-24 md:py-32 border-t border-white/10 overflow-hidden">
      <Container>
        <FadeUp>
          <div className="flex items-end justify-between gap-6">
            <div>
              <div className="font-mono-x text-xs tracking-[0.24em] text-white/40 uppercase">
                Chapter 07 · Use Cases
              </div>
              <h2 className="mt-4 font-display text-[clamp(2rem,4.5vw,4rem)] tracking-[-0.03em] leading-[0.98] max-w-3xl">
                Built for teams who live where the{" "}
                <span className="font-serif-x italic">market</span> talks.
              </h2>
            </div>
          </div>
        </FadeUp>
      </Container>

      <div className="relative mt-16">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[var(--bg)] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[var(--bg)] to-transparent z-10" />
        <Marquee gradient={false} speed={30} direction="left">
          {USE_CASES.concat(USE_CASES).map((u, i) => (
            <span key={`${u}-${i}`} className="mx-8 md:mx-14 flex items-center gap-6">
              <span className="font-display text-[clamp(2rem,5vw,4.5rem)] tracking-[-0.03em] text-white/85 whitespace-nowrap">
                {u}
              </span>
              <span className="text-white/25 font-serif-x italic text-[clamp(2rem,5vw,4.5rem)]">·</span>
            </span>
          ))}
        </Marquee>
        <div className="mt-6">
          <Marquee gradient={false} speed={26} direction="right">
            {USE_CASES.concat(USE_CASES).map((u, i) => (
              <span key={`${u}-rev-${i}`} className="mx-8 md:mx-14 flex items-center gap-6 opacity-40">
                <span className="font-display text-[clamp(1.5rem,3.5vw,3rem)] tracking-[-0.03em] whitespace-nowrap">
                  {u}
                </span>
                <span className="font-serif-x italic text-[clamp(1.5rem,3.5vw,3rem)]">·</span>
              </span>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
